import { createSlice } from '@reduxjs/toolkit';

import authInitialState from './initialState';
import reducers from './reducers';

const authSlice = createSlice({
  name: '@auth',
  initialState: authInitialState,
  reducers,
});

export const authActions = authSlice.actions;
export const authReducers = authSlice.reducer;
